import Polyglot from 'node-polyglot';
import { polyglotRegistry } from '@cyberint/common-utils';
import strings from './resources';

const polyglot = new Polyglot({
  locale: polyglotRegistry.getLocale(),
  phrases: { ...strings }
});

polyglotRegistry.register(polyglot, {
  en: { ...strings },
  loaders: {
    es: () => import(/* webpackChunkName: "common-apps-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "common-apps-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "common-apps-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "common-apps-locale-th" */ './locales/th')
  }
});

export const t = (key, params, defaultValue) =>
  polyglot.t(key, {
    ...params,
    _: defaultValue || key
  });

export const sharedAppStrings = strings;
